import React from 'react';
import {Box, styled} from '@mui/material';
import {
  designSystemToken,
  Headline,
  Body,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

const Container = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '57px 20px',
  boxSizing: 'border-box',
  overflow: 'hidden',
}));

const ContentWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '24px',
}));

const IllustrationContainer = styled(Box)(() => ({
  width: '154px',
  height: '162px',
  backgroundImage: `url('https://storage.googleapis.com/brands-public-assets/content-lab/captions-empty.png')`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
}));

const TextContent = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
  textAlign: 'center',
  width: '218px',
}));

function EmptyCaptionsContent() {
  return (
    <Container>
      <ContentWrapper>
        <IllustrationContainer />
        <TextContent>
          <Headline size="md" color={designSystemToken('semantic.fg.primary')}>
            {translate('Smart Captions for Every Audience')}
          </Headline>
          <Body size="lg" color={designSystemToken('semantic.fg.secondary')}>
            {translate(
              'Add captions, refine your script, and translate instantly.'
            )}
          </Body>
        </TextContent>
      </ContentWrapper>
    </Container>
  );
}

export default EmptyCaptionsContent;
